import PropTypes from 'prop-types';

export const DelayPropType = PropTypes.shape({
  quantity: PropTypes.number,
  unit: PropTypes.string,
});

export const GenerationSettingsPropType = PropTypes.shape({
  instructions: PropTypes.string,
  type: PropTypes.string,
  generator: PropTypes.string,
  template: PropTypes.string,
  incentive: PropTypes.string,
  delay: DelayPropType,
});
